import { SHARED_PLATFORM_ROUTES } from '@shared/constants';

export const PLATFORM_ROUTES = SHARED_PLATFORM_ROUTES;
